<template>
  <div class="ticketing-payment-wrapper" ref="ticketing-payment-wrapper">
    <a-modal
      v-model="isTicketingPaymentShown"
      destroy-on-close
      :title="`请使用微信扫码支付`"
      :body-style="{ textAlign: 'center' }"
      :mask-closable="false"
      :get-container="getContainer"
    >
      <img class="qrcode" :src="qrcode" />
      <p>请于60秒之内完成支付...</p>
      <template v-slot:footer>
        <a-button @click="toggle">取消支付</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { getOrderDetailStatus } from "../api/api-ticket";

export default {
  components: {},
  data() {
    return {
      isTicketingPaymentShown: false,
      orderId: undefined,
      qrcode: undefined,
      payment: undefined
    };
  },
  computed: {
    paymentType() {
      return "wechat";
    },
    paymentTypeTitle() {
      if (this.paymentType === "wechat") return "微信";
      return "";
    }
  },
  watch: {
    isTicketingPaymentShown(flag) {
      if (flag) {
        this.handleMonitor();
      } else {
        clearTimeout(this.timer);
      }
    }
  },
  methods: {
    ...mapActions(["getOrderDetailStatus"]),
    toggle({ orderId, qrcode, payment } = {}) {
      this.orderId = orderId;
      this.qrcode = qrcode;
      this.payment = payment;
      this.isTicketingPaymentShown = !this.isTicketingPaymentShown;
    },
    getContainer() {
      return this.$refs["ticketing-payment-wrapper"];
    },
    async handleMonitor(result = {}) {
      const { status, ordersn } = result;
      if (status === 1) {
        // this.$notification.success({
        //   message: '成功',
        //   description: '支付成功，已跳转到当前订单记录'
        // })
        this.$emit("succeed", ordersn);
        return;
      }
      if (status === 2) {
        this.$notification.error({
          message: "错误",
          description: "订单超时，请重新下单"
        });
        this.toggle();
        return;
      }
      const data = await getOrderDetailStatus({ id: this.orderId });
      this.timer = setTimeout(() => {
        this.handleMonitor(data);
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
.ticketing-payment-wrapper {
  /deep/ .brand-icon-wrapper {
    .brand-icon {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
